import React from "react";
import ReactDOM from "react-dom";
import Hunt from "huntjs";

import VideoSection from "./VideoSection";

const videoSectionContainers = document.querySelectorAll(
  "[data-video-section]"
);

// eslint-disable-next-line no-unused-vars
const observer = new Hunt(videoSectionContainers, {
  offset: 1200,
  enter: (videoSectionContainer) => {
    const { json, allowTitle, overviewUrl } = videoSectionContainer.dataset;

    const data = JSON.parse(json);

    ReactDOM.render(
      <VideoSection
        {...data}
        overviewUrl={overviewUrl || undefined}
        allowTitle={JSON.parse(allowTitle)}
      />,
      videoSectionContainer
    );

    window.updateElementQueries();
  },
});
